import api from '@services/api';

/**
 * <p>
 * API endpoints that cover all monthly expense related CRUD calls
 */
export const MonthlyExpenseApi = api.injectEndpoints({
  endpoints: (builder) => ({
    authorizeMonthlyExpense: builder.mutation<void, string>({
      query: (period: string) => ({
        url: `/indirect/monthly-expense/authorize?period=${period}`,
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
  }),
});

export const { useAuthorizeMonthlyExpenseMutation } = MonthlyExpenseApi;
